/* eslint-disable max-len */
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { toJS } from 'mobx';

import Iframe from 'react-iframe';

import classNames from 'classnames';
import ReactHtmlParser from 'react-html-parser';

import { Button, Checkbox, Confirm, Icon, Loader, Menu, Popup } from 'semantic-ui-react';

import '../../css/FileViewerModal.less';

import { CONTENT_MODE } from '../../managers/ContentManager';

import Auth from '../../managers/AuthManager';
// import { _dcEvent, _dcData } from '../../managers/DocReaderManager';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import ActivityInstanceUserNavigationService from '../../services/ActivityInstanceUserNavigationService';
import UtilityService from '../../services/UtilityService';

import { makeAutoFocusable, makeKeyboardAccessible } from '../../utils';
import { stripHtmlTags } from '../../utils/stripHtml';

import Modal from '../Modal';

export default
@inject('assignmentManager', 'classroomManager', 'contentManager',
  'docReaderManager', 'gradebookManager', 'studentContentCardManager', 'userManager')
class DocReaderModal extends Component {
    received = false;
    //    _cwin = null;

    constructor(props) {
      super(props);
      this.InfoModal = SatCoreComponent('InfoModal');
      this.ScoreAssignmentModal = SatCoreComponent('ScoreAssignmentModal');
      // this.PrintDocreaderPageModal = SatCoreComponent('PrintDocreaderPageModal');
      this.state = {
        // showPrintPageModal: false,
        addInfoOpen: false,
        confirmationOpen: false,
        contentUrl: null,
        currentInstance: null,
        currentAssignment: null,
        interval: null,
        isLoading: true,
        isOptionsDropdownOpen: false,
        isToolsDropdownOpen: false,
        showAnnotations: false,
        showScoreModal: false
      };
    }

    async componentDidMount() {
      const {
        activityId,
        assignmentId,
        assignmentManager,
        contentItemId,
        contentManager,
        contentMode,
        gradebookManager,
        page,
        studentContentCardManager
      } = this.props;

      try {
        // Set flag to prevent Gradebook from showing loader when modal is open
        gradebookManager.setIsFileViewerOrDocReaderModalOpen(true);

        // Set contentUrl on initial load so state is the single source of truth
        // This prevents falling back to potentially stale observable values during navigation
        const initialUrl = contentManager.docReaderUrl;
        this.setState({ contentUrl: initialUrl });

        // Initialize currentInstance for navigation if applicable
        if (gradebookManager.assignmentInstancesMap && assignmentId) {
          const currentInstance = ActivityInstanceUserNavigationService.getCurrentActivityInstanceForUser(
            gradebookManager.assignmentInstancesMap,
            assignmentId
          );
          this.setState({ currentInstance });
        }

        // Store initial assignment to use as fallback during navigation
        if (activityId) {
          const initialAssignment = await assignmentManager.getAssignmentAsync(activityId);
          if (initialAssignment) {
            this.setState({ currentAssignment: toJS(initialAssignment) });
          }
        }
        if (page && page === 'file-viewer') {
          window.addEventListener('message', this.handleIframeTask);
        }
        if (contentMode === CONTENT_MODE.ASSESS) {
          const sessionStart = new Date();
          this.setState({
            interval:
          setInterval(async () => {
            const sessionPing = new Date();
            let viewedTime = (sessionPing - sessionStart) / 1000;
            viewedTime = viewedTime.toFixed(0);
            assignmentManager.markActivityViewed(activityId, contentItemId, viewedTime);
          }, 10000)
          });
        }
        if (studentContentCardManager.isLoading) {
          studentContentCardManager.setIsLoading(false);
        }
      } finally {
        this.setState({ isLoading: false });
      }
    }

    async componentWillUnmount() {
      const { docReaderManager, gradebookManager } = this.props;
      const { interval } = this.state;
      // await docReaderManager.doSaveActions();
      await docReaderManager.clearHighlightsAnnotations();
      clearInterval(interval);
      window.removeEventListener('message', this.handleIframeTask);
      window.removeEventListener('message', docReaderManager._relay);

      // Clear flag to allow Gradebook to show loader again
      gradebookManager.setIsFileViewerOrDocReaderModalOpen(false);
    }

    handleOpenInfo = () => {
      this.setState({ addInfoOpen: true });
    }

    closeInfoModal = () => {
      this.setState({ addInfoOpen: false });
    }

    handleIframeTask = (e) => {
      const { closeIframeCallback, closeModalCallback } = this.props;
      const { isLoading } = this.state;

      if (isLoading) {
        return;
      }

      if (e.origin === Auth.publisher && e.data === 'closePressed') {
        // Use closeIframeCallback if provided, otherwise fall back to closeModalCallback
        const callback = closeIframeCallback || closeModalCallback;

        if (callback) {
          callback();
        }
      }
    };

    openGradeAssignment = () => {
      this.setState({ showScoreModal: true });
    }

    closeGradeAssignment = () => {
      const { gradebookManager } = this.props;
      const { currentInstance } = this.state;

      // Refresh the currentInstance from the map to get updated score data
      if (currentInstance && gradebookManager.assignmentInstancesMap) {
        const updatedInstance = gradebookManager.assignmentInstancesMap.get(currentInstance.id);
        if (updatedInstance) {
          this.setState({
            currentInstance: toJS(updatedInstance),
            showScoreModal: false
          });
        } else {
          this.setState({ showScoreModal: false });
        }
      } else {
        this.setState({ showScoreModal: false });
      }

      this.refreshClassroomData();
    }

    openPrintPage = () => {
      const { docReaderManager } = this.props;
      docReaderManager.doPagePrint();
    }

    refreshClassroomData = async () => {
      const { classroomManager, isFromLTI } = this.props;
      if (!isFromLTI) {
        await classroomManager.fetchClassroomData(classroomManager.currentClassroomId);
      }
    }

    submitAndClose = async () => {
      const { assignmentManager, closeModalCallback, userManager, assignmentId } = this.props;
      if (!userManager.canViewAsTeacher) {
        await assignmentManager.submitActivityInstance(assignmentId);
      }
      closeModalCallback();
    }

    startSubmit = async () => {
      this.setState({ confirmationOpen: true });
    }

    // TODO remove; unused
    // doInit = async () => {
    //   const { docReaderManager } = this.props;
    //   docReaderManager.setContentWindow(document.getElementById('dcr-frame').contentWindow);
    //   setTimeout(() => {
    //     docReaderManager.addEventListeners();
    //   }, 10000);
    // }

    // TODO remove; unused
    // noCallback = () => {
    //   console.info('No Callback');
    // }

    initializeDocReaderFrame = async () => {
      const { docReaderManager } = this.props;
      await docReaderManager.initializeDocReaderFrame();
    }

    activateAnnotationTool = () => {
      const { docReaderManager } = this.props;
      docReaderManager.activateAnnotationTool();
    }

    activateHighlightTool = () => {
      const { docReaderManager } = this.props;
      docReaderManager.activateHighlightTool();
    }

    hideBothTools = () => {
      const { docReaderManager } = this.props;
      docReaderManager.hideBothTools();
    }

    neutralizeBothTools = () => {
      const { docReaderManager } = this.props;
      docReaderManager.neutralizeBothTools();
    }

    saveCurrentPage = async () => {
      // Set loading state IMMEDIATELY to disable buttons during save
      this.setState({ isLoading: true });

      try {
        const { docReaderManager } = this.props;
        await docReaderManager.doSaveActions(false);
      } finally {
        this.setState({ isLoading: false });
      }
    }

    printCurrentPage = async () => {
      setTimeout(() => {
        this.openPrintPage();
      }, 1000);
    }

    doPageChangedActions = () => {
      const { docReaderManager } = this.props;
      docReaderManager.doPageChangedActions();
    }

    closeConfirmation = async () => {
      this.setState({ confirmationOpen: false });
    }

    allowRenderScoreButton = () => {
      const { contentMode, userManager } = this.props;
      return contentMode === CONTENT_MODE.REVIEW && userManager.canViewAsTeacher;
    }

    handleChangeToggle = (_event, data) => {
      this.setState({
        showAnnotations: data.checked
      });

      if (!data.checked) {
        this.neutralizeBothTools();
      } else {
        this.hideBothTools();
      }
    }

    handlePreviousStudent = async () => {
      /* eslint-disable no-console */
      // Set loading state IMMEDIATELY to disable buttons and unmount iframe
      this.setState({ isLoading: true });

      try {
        const { assignmentManager, contentManager, docReaderManager, gradebookManager } = this.props;
        const { currentAssignment, currentInstance } = this.state;

        if (!gradebookManager.assignmentInstancesMap || !currentInstance) {
          return; // finally block will still execute to reset isLoading
        }

        // Save current user work before navigating
        await docReaderManager.doSaveActions();

        // Clear current annotations from DocReaderManager before loading new student
        await docReaderManager.clearHighlightsAnnotations();

        // Remove event listeners before iframe is destroyed to prevent duplicate listeners
        window.removeEventListener('message', docReaderManager._relay);

        // Get previous activity instance for user using ActivityInstanceUserNavigationService
        const prevInstance = ActivityInstanceUserNavigationService.getPreviousActivityInstanceForUser(
          gradebookManager.assignmentInstancesMap,
          currentInstance.id
        );
        if (!prevInstance) {
          console.warn('No previous student available');
          return;
        }

        // Get assignment for the new student
        const fetchedAssignment = await assignmentManager.getAssignmentAsync(prevInstance.activityId);

        // Ensure assignment has required fields, using fallback from current assignment if needed
        const assignment = {
          ...fetchedAssignment,
          contentItemEntityTypeId: fetchedAssignment.contentItemEntityTypeId || currentAssignment?.contentItemEntityTypeId,
          pdfDeliveryFormat: fetchedAssignment.pdfDeliveryFormat || currentAssignment?.pdfDeliveryFormat
        };

        // Set session ID FIRST to ensure it's available before iframe loads
        contentManager.setCurrentFlowPaperSessionId(prevInstance.id);

        // Use getOptionsForTeacherReviewAndScoring to fetch URL and set up content
        const options = await contentManager.getOptionsForTeacherReviewAndScoring(
          assignment,
          prevInstance,
          window.location.origin,
          true,
          assignment.courseResourceElementId,
          assignment.id
        );

        if (!options || !options.viewUrl) {
          throw new Error('Failed to get DocReader options for previous student');
        }

        // Update state with new instance, URL, and assignment for future navigation
        this.setState({
          contentUrl: options.viewUrl,
          currentAssignment: toJS(assignment),
          currentInstance: prevInstance
        });
      } catch (error) {
        console.error('Error navigating to previous student:', error);
        // Keep modal open and keep current student loaded on error
      } finally {
        // Clear loading state
        this.setState({ isLoading: false });
      }
    }

    handleNextStudent = async () => {
      // Set loading state IMMEDIATELY to disable buttons and unmount iframe
      this.setState({ isLoading: true });

      try {
        const { assignmentManager, contentManager, docReaderManager, gradebookManager } = this.props;
        const { currentAssignment, currentInstance } = this.state;

        if (!gradebookManager.assignmentInstancesMap || !currentInstance) {
          return; // finally block will still execute to reset isLoading
        }

        // Save current user work before navigating
        await docReaderManager.doSaveActions();

        // Clear current annotations from DocReaderManager before loading new student
        await docReaderManager.clearHighlightsAnnotations();

        // Remove event listeners before iframe is destroyed to prevent duplicate listeners
        window.removeEventListener('message', docReaderManager._relay);

        // Get next activity instance for user using ActivityInstanceUserNavigationService
        const nextInstance = ActivityInstanceUserNavigationService.getNextActivityInstanceForUser(
          gradebookManager.assignmentInstancesMap,
          currentInstance.id
        );
        if (!nextInstance) {
          console.warn('No next student available');
          return;
        }

        // Get assignment for the new student
        const fetchedAssignment = await assignmentManager.getAssignmentAsync(nextInstance.activityId);

        // Ensure assignment has required fields, using fallback from current assignment if needed
        const assignment = {
          ...fetchedAssignment,
          contentItemEntityTypeId: fetchedAssignment.contentItemEntityTypeId || currentAssignment?.contentItemEntityTypeId,
          pdfDeliveryFormat: fetchedAssignment.pdfDeliveryFormat || currentAssignment?.pdfDeliveryFormat
        };

        // Set session ID FIRST to ensure it's available before iframe loads
        contentManager.setCurrentFlowPaperSessionId(nextInstance.id);

        // Use getOptionsForTeacherReviewAndScoring to fetch URL and set up content
        const options = await contentManager.getOptionsForTeacherReviewAndScoring(
          assignment,
          nextInstance,
          window.location.origin,
          true,
          assignment.courseResourceElementId,
          assignment.id
        );

        if (!options || !options.viewUrl) {
          throw new Error('Failed to get DocReader options for next student');
        }

        // Update state with new instance, URL, and assignment for future navigation
        this.setState({
          contentUrl: options.viewUrl,
          currentAssignment: toJS(assignment),
          currentInstance: nextInstance
        });
      } catch (error) {
        console.error('Error navigating to next student:', error);
        // Keep modal open and keep current student loaded on error
      } finally {
        // Clear loading state
        this.setState({ isLoading: false });
      }
      /* eslint-enable no-console */
    }

    // Header Actions
    renderHeaderActions = () => {
      return (
        <div className='modal-title-button doc-reader-actions'>
          {this.renderMarkupToggle()}
          {this.renderScoreButton()}
          {this.renderPreviousStudentButton()}
          {this.renderNextStudentButton()}
          {this.renderToolsDropdown()}
          {this.renderOptionsDropdown()}
          {this.renderCloseButton()}
          {this.renderSubmitButton()}
        </div>
      );
    }

    renderMarkupToggle = () => {
      const { userManager, contentMode, t } = this.props;
      const { isLoading, showAnnotations } = this.state;

      if ((!userManager.canViewAsTeacher && contentMode === CONTENT_MODE.ASSESS) || userManager.canViewAsTeacher) {
        const handleToggleMarkup = () => {
          const newValue = !showAnnotations;
          this.handleChangeToggle(null, { checked: newValue });
        };

        return (
          <div className='toggle-hide-or-show-wrapper' {...makeKeyboardAccessible(handleToggleMarkup, {
            ariaLabel: `${showAnnotations ? t('hideMarkup') : t('showMarkup')}`
          })}>
            <Checkbox
              checked={showAnnotations}
              className='hide-or-show-toggler hide-or-show-toggler-directly-on-background'
              disabled={isLoading}
              label={t('markup')}
              onChange={(event, data) => this.handleChangeToggle(event, data)}
              toggle />
          </div>
        );
      }
      return null;
    }

    renderPreviousStudentButton = () => {
      const { gradebookManager, isFromGradebook, t } = this.props;
      const { isLoading, showAnnotations } = this.state;
      const allowScoring = this.allowRenderScoreButton();

      // Only show navigation when opened from gradebook
      if (!isFromGradebook) {
        return null;
      }

      // Only show navigation when scoring is allowed and navigation is applicable
      if (!allowScoring || !gradebookManager.assignmentInstancesMap) {
        return null;
      }

      // Check if navigation should be enabled using ActivityInstanceUserNavigationService
      const enableNavigation = ActivityInstanceUserNavigationService.shouldEnableNavigation(
        gradebookManager.assignmentInstancesMap
      );

      if (!enableNavigation) {
        return null;
      }

      return (
        <Button
          className='file-viewer-prev-student-btn basic white'
          disabled={showAnnotations || isLoading}
          onClick={this.handlePreviousStudent}
          primary>
          <div className='file-viewer-prev-student-btn-content-inner-wrapper'>
            <div className='file-viewer-btn-nav-icon-wrapper prev-student-btn-icon-wrapper'>
              <Icon className='prev-student-nav-icon' name='angle up' size='large' />
            </div>
            <div className='file-viewer-btn-text prev-student-btn-text'>{t('previousStudent')}</div>
          </div>
        </Button>
      );
    }

    renderNextStudentButton = () => {
      const { gradebookManager, isFromGradebook, t } = this.props;
      const { isLoading, showAnnotations } = this.state;
      const allowScoring = this.allowRenderScoreButton();

      // Only show navigation when opened from gradebook
      if (!isFromGradebook) {
        return null;
      }

      // Only show navigation when scoring is allowed and navigation is applicable
      if (!allowScoring || !gradebookManager.assignmentInstancesMap) {
        return null;
      }

      // Check if navigation should be enabled using ActivityInstanceUserNavigationService
      const enableNavigation = ActivityInstanceUserNavigationService.shouldEnableNavigation(
        gradebookManager.assignmentInstancesMap
      );

      if (!enableNavigation) {
        return null;
      }

      return (
        <Button
          className='file-viewer-next-student-btn basic white'
          disabled={showAnnotations || isLoading}
          onClick={this.handleNextStudent}
          primary>
          <div className='file-viewer-next-student-btn-content-inner-wrapper'>
            <div className='file-viewer-btn-nav-icon-wrapper next-student-btn-icon-wrapper'>
              <Icon className='next-student-nav-icon' name='angle down' size='large' />
            </div>
            <div className='file-viewer-btn-text next-student-btn-text'>{t('nextStudent')}</div>
          </div>
        </Button>
      );
    }

    renderToolsDropdownItemHighlights = () => {
      const { userManager, t } = this.props;
      const { isToolsDropdownOpen, showAnnotations } = this.state;

      return (
        <Menu.Item
          as='div'
          role='menuitem'
          tabIndex={isToolsDropdownOpen ? '0' : '-1'}>
          <Button
            className={`file-viewer-dropdown-btn-highlights ${!userManager.canViewAsTeacher ? 'basic student white' : ''}`}
            disabled={showAnnotations}
            fluid
            onClick={() => {
              this.activateHighlightTool();
              this.setState({ isToolsDropdownOpen: false });
            }}
            primary
            tabIndex='-1'>
            {t('highlightsButtonLabel')}
          </Button>
        </Menu.Item>
      );
    }

    renderToolsDropdownItemAnnotations = () => {
      const { userManager, t } = this.props;
      const { isToolsDropdownOpen, showAnnotations } = this.state;

      return (
        <Menu.Item
          as='div'
          role='menuitem'
          tabIndex={isToolsDropdownOpen ? '0' : '-1'}>
          <Button
            className={`file-viewer-dropdown-btn-annotations ${!userManager.canViewAsTeacher ? 'basic student white' : ''}`}
            disabled={showAnnotations}
            fluid
            onClick={() => {
              this.activateAnnotationTool();
              this.setState({ isToolsDropdownOpen: false });
            }}
            primary
            tabIndex='-1'>
            {t('annotationsButtonLabel')}
          </Button>
        </Menu.Item>
      );
    }

    renderToolsDropdown = () => {
      const { userManager, contentMode, t } = this.props;
      const { isLoading, isToolsDropdownOpen, showAnnotations } = this.state;

      if ((!userManager.canViewAsTeacher && contentMode === CONTENT_MODE.ASSESS) || userManager.canViewAsTeacher) {
        const triggerButton = (
          <Button
            aria-expanded={isToolsDropdownOpen}
            aria-haspopup='true'
            className='tools-dropdown'
            disabled={showAnnotations || isLoading}
            onClick={() => this.setState({ isToolsDropdownOpen: !isToolsDropdownOpen })}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.setState({ isToolsDropdownOpen: !isToolsDropdownOpen });
              }
            }}
            // onMouseEnter={() => this.setState({ isToolsDropdownOpen: true })}
            primary
            tabIndex='0'>
            {t('toolsButtonLabel')}{' '}
            <Icon name='angle down' size='large' />
          </Button>
        );

        return (
          <Popup
            basic
            className='file-viewer-tools-popup'
            mouseEnterDelay={500}
            offset={[0, -9]}
            on='click'
            onClose={() => this.setState({ isToolsDropdownOpen: false })}
            onMount={() => {
              makeAutoFocusable(
                '.file-viewer-tools-popup.visible .ui.vertical.menu',
                () => this.setState({ isToolsDropdownOpen: false })
              );
              // // Ensure popup is visible in viewport
              // const popup = document.querySelector('.file-viewer-tools-popup.visible');
              // if (popup) {
              //   popup.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
              // }
            }}
            onMouseLeave={() => this.setState({ isToolsDropdownOpen: false })}
            open={isToolsDropdownOpen}
            position='bottom left'
            positionFixed
            trigger={triggerButton}>
            <Menu role='menu' vertical>
              {this.renderToolsDropdownItemHighlights()}
              {this.renderToolsDropdownItemAnnotations()}
            </Menu>
          </Popup>
        );
      }
      return null;
    }

    renderOptionsDropdownItemStudentInstructions = () => {
      const { instruction, userManager, t } = this.props;
      const { isOptionsDropdownOpen } = this.state;

      if (!instruction || instruction === '<p></p>') {
        return null;
      }

      return (
        <Menu.Item
          as='div'
          role='menuitem'
          tabIndex={isOptionsDropdownOpen ? '0' : '-1'}>
          <Button
            className={`file-viewer-dropdown-btn-student-instructions ${!userManager.canViewAsTeacher ? 'basic student-instruction white' : 'basic white'}`}
            fluid
            onClick={() => {
              this.handleOpenInfo();
              this.setState({ isOptionsDropdownOpen: false });
            }}
            primary
            tabIndex='-1'>
            {t('studentInstructionsButtonLabel')}
          </Button>
        </Menu.Item>
      );
    }

    renderOptionsDropdownItemSave = () => {
      const { userManager, contentMode, t } = this.props;
      const { isOptionsDropdownOpen, showAnnotations } = this.state;

      if (!((!userManager.canViewAsTeacher && contentMode === CONTENT_MODE.ASSESS) || userManager.canViewAsTeacher)) {
        return null;
      }

      return (
        <Menu.Item
          as='div'
          role='menuitem'
          tabIndex={isOptionsDropdownOpen ? '0' : '-1'}>
          <Button
            className={`file-viewer-dropdown-btn-save ${!userManager.canViewAsTeacher ? 'basic student white' : ''}`}
            disabled={showAnnotations}
            fluid
            onClick={async () => {
              await this.saveCurrentPage();
              this.setState({ isOptionsDropdownOpen: false });
            }}
            primary
            tabIndex='-1'>
            {t('saveButtonLabel')}
          </Button>
        </Menu.Item>
      );
    }

    renderOptionsDropdownItemPrint = () => {
      const { userManager, t } = this.props;
      const { contentUrl, isOptionsDropdownOpen, showAnnotations } = this.state;

      // Check if printing is enabled
      let isPrintEnabled = false;
      try {
        if (contentUrl) {
          const { searchParams } = new URL(contentUrl);
          const confValue = searchParams.get('conf');
          isPrintEnabled = confValue === 'printenabled';
        }
      } catch {
        // Do nothing if URL parsing fails
      }

      if (!isPrintEnabled) {
        return null;
      }

      return (
        <Menu.Item
          as='div'
          role='menuitem'
          tabIndex={isOptionsDropdownOpen ? '0' : '-1'}>
          <Popup
            className='gradebook-summary-table-popup file-viewer-print-popup'
            hideOnScroll
            hoverable
            mouseEnterDelay={500}
            on='hover'
            position='top center'
            trigger={(
              <Button
                className={`file-viewer-dropdown-btn-print ${!userManager.canViewAsTeacher ? 'basic student white' : ''}`}
                disabled={showAnnotations}
                fluid
                onClick={() => {
                  this.printCurrentPage();
                  this.setState({ isOptionsDropdownOpen: false });
                }}
                primary
                tabIndex='-1'>
                {t('printButtonLabel')}
              </Button>
            )}>
            <Popup.Header><div className='popup-message header'>{t('printPopupHeader')}</div></Popup.Header>
            <Popup.Content>
              <div className='popup-message'>{t('printPopupContent')}</div>
            </Popup.Content>
          </Popup>
        </Menu.Item>
      );
    }

    renderOptionsDropdown = () => {
      const { t } = this.props;
      const { isLoading, isOptionsDropdownOpen, showAnnotations } = this.state;

      const triggerButton = (
        <Button
          aria-expanded={isOptionsDropdownOpen}
          aria-haspopup='true'
          className='options-dropdown'
          disabled={showAnnotations || isLoading}
          onClick={() => this.setState({ isOptionsDropdownOpen: !isOptionsDropdownOpen })}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.setState({ isOptionsDropdownOpen: !isOptionsDropdownOpen });
            }
          }}
          // onMouseEnter={() => this.setState({ isOptionsDropdownOpen: true })}
          primary
          tabIndex='0'>
          {t('optionsButtonLabel')}{' '}
          <Icon name='angle down' size='large' />
        </Button>
      );

      return (
        <Popup
          basic
          className='file-viewer-options-popup'
          offset={[0, -9]}
          on='click'
          onClose={() => this.setState({ isOptionsDropdownOpen: false })}
          onMount={() => {
            makeAutoFocusable(
              '.file-viewer-options-popup.visible .ui.vertical.menu',
              () => this.setState({ isOptionsDropdownOpen: false })
            );
            // // Ensure popup is visible in viewport
            // const popup = document.querySelector('.file-viewer-options-popup.visible');
            // if (popup) {
            //   popup.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            // }
          }}
          onMouseLeave={() => this.setState({ isOptionsDropdownOpen: false })}
          open={isOptionsDropdownOpen}
          position='bottom left'
          positionFixed
          trigger={triggerButton}>
          <Menu role='menu' vertical>
            {this.renderOptionsDropdownItemStudentInstructions()}
            {this.renderOptionsDropdownItemSave()}
            {this.renderOptionsDropdownItemPrint()}
          </Menu>
        </Popup>
      );
    }

    renderCloseButton = () => {
      const { userManager, closeModalCallback, t } = this.props;
      const { isLoading } = this.state;
      return (
        <Button
          className={`file-viewer-close-btn ${!userManager.canViewAsTeacher ? 'basic student white' : ''}`}
          disabled={isLoading}
          onClick={() => closeModalCallback()}
          primary>
          {t('closeButtonLabel')}
        </Button>
      );
    }

    renderSubmitButton = () => {
      const { userManager, contentMode, t } = this.props;
      const { isLoading } = this.state;
      if (!userManager.canViewAsTeacher && contentMode === CONTENT_MODE.ASSESS) {
        return (<Button className='file-viewer-submit-btn student' disabled={isLoading} onClick={() => this.startSubmit()} primary>{t('submitButtonLabel')}</Button>);
      }
      return null;
    }

    renderScoreButton = () => {
      const { userManager, contentMode, t } = this.props;
      const { isLoading } = this.state;
      if (contentMode === CONTENT_MODE.REVIEW && userManager.canViewAsTeacher) {
        return (<Button className='file-viewer-score-btn basic white' disabled={isLoading} onClick={() => this.openGradeAssignment()} primary>{t('scoreButtonLabel')}</Button>);
      }
      return null;
    }

    // TODO remove
    // renderDivider = () => {
    //   const { instruction } = this.props;
    //   if (instruction && instruction !== '<p></p>') {
    //     return (<div className='divider' />);
    //   }
    //   return null;
    // }

    renderInfoModalIfApplicable = () => {
      const { instruction, contentName, contentImageUrl } = this.props;
      const { addInfoOpen } = this.state;
      const { InfoModal } = this;

      return (
        <InfoModal
          addInfoOpen={addInfoOpen}
          closeInfoModal={this.closeInfoModal}
          contentItemDescription={null}
          imageUrl={contentImageUrl}
          infoName={contentName}
          resourceInfo={null}
          studentInstruction={instruction} />
      );
    }

    renderConfirmModalIfApplicable = () => {
      const { t } = this.props;
      const { confirmationOpen } = this.state;

      return (
        <Confirm
          cancelButton={t('confirmCancelButton')}
          confirmButton={t('confirmConfirmButton')}
          content={t('confirmContent')}
          header={t('confirmHeader')}
          onCancel={() => this.setState({ confirmationOpen: false })}
          onConfirm={() => {
            this.submitAndClose();
            this.setState({ confirmationOpen: false });
          }}
          open={confirmationOpen} />
      );
    }

    renderScoreAssignmentModalIfApplicable = () => {
      const { assignmentId, grade, maxScore, studentName, totalScore } = this.props;
      const { currentInstance, showScoreModal } = this.state;
      const { ScoreAssignmentModal } = this;

      // Use currentInstance if available (navigation context), otherwise use props
      const currentInstanceId = currentInstance?.id || assignmentId;
      const currentStudentName = currentInstance
        ? ActivityInstanceUserNavigationService.formatActivityInstanceUserName(currentInstance)
        : studentName;
      const currentGrade = currentInstance ? currentInstance.grade : grade;
      const currentTotalScore = currentInstance ? currentInstance.totalScore : totalScore;

      return (
        <ScoreAssignmentModal
          key={currentInstanceId}
          activityInstanceId={currentInstanceId}
          allowScoreAssignmentModalInfoSessionStorage={false}
          closeGradeAssignment={this.closeGradeAssignment}
          grade={currentGrade || 0}
          gradeAssignmentOpen={showScoreModal}
          maxScore={maxScore || 100}
          studentName={currentStudentName}
          totalScore={currentTotalScore || 0} />
      );
    }

    render() {
      const { userManager, contentMode, contentName, studentName, t } = this.props;
      const { contentUrl, currentInstance, isLoading, showScoreModal } = this.state;
      const transformFn = UtilityService.reactHtmlParserTransform;

      // contentUrl is set on mount and during navigation - log error if missing when iframe should render
      if (!isLoading && !contentUrl) {
        console.error('DocReaderModal: contentUrl not set when attempting to render iframe');
      }

      // Use currentInstance if available (navigation context), otherwise use props
      const currentStudentName = currentInstance
        ? ActivityInstanceUserNavigationService.formatActivityInstanceUserName(currentInstance)
        : studentName;

      const { isOptionsDropdownOpen, isToolsDropdownOpen } = this.state;
      const headerClassName = classNames('f-header', 'doc-reader-header', {
        'dropdown-open': isOptionsDropdownOpen || isToolsDropdownOpen,
      });

      const modalHeaderTitleText = (this.allowRenderScoreButton() || (userManager.canViewAsTeacher && contentMode === 'review'))
        ? `${t('gradebookLabel')}: ${stripHtmlTags(currentStudentName)}`
        : stripHtmlTags(contentName);

      return (
        <>
          <Modal className='f-player-modal DocReaderModal' open size='fullscreen'>
            <div className={headerClassName}>
              <div className='modal-title-text doc-reader-title' title={modalHeaderTitleText}>
                {
                  (this.allowRenderScoreButton() || (userManager.canViewAsTeacher && contentMode === 'review')) ? (
                    <p>
                      {t('gradebookLabel', 'DocReaderModal translation missing.')}
                      :
                      {' '}
                      {ReactHtmlParser(currentStudentName, { transform: transformFn })}
                    </p>
                  ) :
                    <p>{ReactHtmlParser(contentName, { transform: transformFn })}</p>
                }
              </div>
              {this.renderHeaderActions()}
            </div>
            {/* Utilize `--fullscreen-modal-header-nav-separator-display` style var to hide/show (`none`/`unset`) */}
            <div className='fullscreen-modal-nav-separator doc-reader-separator' />
            <div className='f-content doc-reader-content file-viewer-content'>
              {isLoading ? (
                <div className='file-viewer-loading-overlay'>
                  <Loader active size='large' />
                </div>
              ) : (
                <Iframe
                  // key={currentInstance?.id || 'default'}
                  height='100%'
                  id='dcr-frame'
                  onLoad={async () => this.initializeDocReaderFrame()}
                  position='relative'
                  title={UtilityService.stripHtmlTagsAndStrip(contentName)}
                  url={contentUrl}
                  width='100%' />
              )}
            </div>
            {this.renderInfoModalIfApplicable()}
            {this.renderConfirmModalIfApplicable()}
          </Modal>
          {/* Using the modal directly as the dialogManager does not seem to work for modals within the lti iFrame */}
          {!isLoading && showScoreModal && this.renderScoreAssignmentModalIfApplicable()}
        </>
      );
    }
}
SatCoreRegister('DocReaderModal', DocReaderModal);
